export var FileUploaderFileValidationResult = /*#__PURE__*/function () {
  function FileUploaderFileValidationResult(isValid, message) {
    this.isValid = isValid;
    this.message = message;
  }

  FileUploaderFileValidationResult.error = function error(message) {
    return new FileUploaderFileValidationResult(false, message);
  };

  FileUploaderFileValidationResult.ok = function ok() {
    return new FileUploaderFileValidationResult(true);
  };

  return FileUploaderFileValidationResult;
}();